import AuthLayout from "@/views/V2/auth/AuthLayout.vue";
import RegisterV2 from "@/views/V2/auth/register/RegisterV2.vue";
import LoginV2 from "@/views/V2/auth/login/LoginV2.vue";
import RoleSelect from "@/views/V2/auth/role-select/RoleSelect.vue";

export default {
  path: "/v2/auth",
  name: "Auth",
  component: AuthLayout,
  redirect: "/v2/auth/login",
  children: [
    {
      path: "/v2/auth/register",
      component: RegisterV2,
      name: "RegisterV2",
      meta: {
        title: "Registrarse",
      },
    },
    {
      path: "/v2/auth/login",
      component: LoginV2,
      name: "LoginV2",
      meta: {
        title: "Iniciar sesión",
      },
    },
    {
      path: "/v2/auth/role-select",
      component: RoleSelect,
      name: "RoleSelect",
      meta: {
        title: "Seleccionar rol",
      },
    },
  ],
};
